import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/chrome-extension/privacy')({
    component: ChromeExtensionPrivacyPage,
});

function ChromeExtensionPrivacyPage() {
    return (
        <main className="min-h-screen bg-slate-950 px-6 py-16 text-slate-100">
            <div className="mx-auto max-w-3xl space-y-10">
                <header className="space-y-4">
                    <p className="text-sm font-medium tracking-[0.2em] text-sky-300 uppercase">
                        Phoebe
                    </p>
                    <div className="space-y-3">
                        <h1 className="text-4xl font-semibold tracking-tight text-white">
                            Chrome extension privacy policy
                        </h1>
                        <p className="max-w-2xl text-base leading-7 text-slate-300">
                            Phoebe helps coordinators open Phoebe staffing
                            workflows from supported EHR pages. This page
                            explains what extension data is handled, how it is
                            used, and when it is shared.
                        </p>
                    </div>
                </header>
                <section className="space-y-3">
                    <h2 className="text-xl font-semibold text-white">
                        Data we handle
                    </h2>
                    <p className="leading-7 text-slate-300">
                        The extension handles the current supported-page URL,
                        the detected EHR context needed to open Phoebe in the
                        right workflow, Phoebe session data needed to keep the
                        side panel signed in, organization domain settings, and
                        notification metadata needed to show Phoebe alerts in
                        Chrome.
                    </p>
                </section>
                <section className="space-y-3">
                    <h2 className="text-xl font-semibold text-white">
                        How we use data
                    </h2>
                    <p className="leading-7 text-slate-300">
                        We use this data only to provide the extension’s
                        user-facing features: detecting supported EHR pages,
                        opening the Phoebe side panel, preserving organization
                        context, and delivering Phoebe workflow notifications.
                    </p>
                </section>
                <section className="space-y-3">
                    <h2 className="text-xl font-semibold text-white">
                        How data is shared
                    </h2>
                    <p className="leading-7 text-slate-300">
                        Extension data is sent to Phoebe services only when
                        needed to power those workflows. We do not sell
                        extension data or use it for advertising.
                    </p>
                </section>
                <section className="space-y-3">
                    <h2 className="text-xl font-semibold text-white">
                        Data security
                    </h2>
                    <p className="leading-7 text-slate-300">
                        Phoebe services are accessed over secure HTTPS
                        connections. The extension requests only the permissions
                        required to load Phoebe in the side panel, authenticate
                        the signed-in user, read supported page context, and
                        show workflow notifications.
                    </p>
                </section>
                <section className="space-y-3">
                    <h2 className="text-xl font-semibold text-white">
                        Contact
                    </h2>
                    <p className="leading-7 text-slate-300">
                        For privacy questions about Phoebe, contact
                        success@phoebe.work.
                    </p>
                </section>
            </div>
        </main>
    );
}
